if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = Math.trunc(targetLength) || 0;
    padString = padString == null ? ' ' : String(padString);
    if (this.length >= targetLength) return String(this);

    targetLength -= this.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(Math.ceil(targetLength / padString.length));
    }
    return padString.slice(0, targetLength) + String(this);
  };
}

export {};
